import React from "react";
import { connect } from "react-redux";
import { loadTabs } from "../Header/actions";

// tabs
import InicioPlanMovilidad from "./Inicio/view";
import PlanesMovilidad from "./Planes/view";
import Accidentes from "./Accidentes/view";
import Administracion from "./Administracion/view";
import { checkAccess, ids } from "../../helpers/rolAccess";

class PlanMovilidad extends React.PureComponent {
  constructor(props) {
    super(props);
    this.loadTabs();
  }

  componentDidUpdate = () => {
    if (this.props.currentHeader !== "Plan de Movilidad Traslado Seguro") {
      this.loadTabs();
    }
  }

  loadTabs = () => {
    const tabs = [];
    if (checkAccess(ids.gestorMovilidad, this.props.userAccessIds)) tabs.push({ text: "Inicio", contentId: 0 });
    if (checkAccess(ids.gestorMovilidad, this.props.userAccessIds)) tabs.push({ text: "Plan de Movilidad", contentId: 1 });
    if (checkAccess(ids.gestorMovilidad, this.props.userAccessIds)) tabs.push({ text: "Accidentes", contentId: 2 });
    if (checkAccess(ids.adminMovilidad, this.props.userAccessIds)) tabs.push({ text: "Administración", contentId: 3 });

    this.props.dispatch(loadTabs("Plan de Movilidad Traslado Seguro", "", tabs, tabs.length ? tabs[0].contentId : null));
  }

  renderBody = () => {
    switch (this.props.selectedTab) {
      case 0: {
        return (<InicioPlanMovilidad />);
      }
      case 1: {
        return (<PlanesMovilidad />);
      }
      case 2: {
        return (<Accidentes />);
      }
      case 3: {
        return (<Administracion />);
      }
      default:
        return <div />;
    }
  }

  render() {
    return (
      <React.Fragment>
        {this.renderBody()}
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  selectedTab: state.header.contentId,
  currentHeader: state.header.title,
  userAccessIds: state.global.userAccessIds,
});

const mapDispatchToProps = (dispatch) => ({
  dispatch: (action) => { dispatch(action); },
});

export default connect(mapStateToProps, mapDispatchToProps)(PlanMovilidad);
